import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { mqUser, mqMin } from 'utils/responsive';
import LogoImg from 'ui/images/logo_buyer.svg';
import BuyerLoginImg from 'ui/images/top_for_buyer/sp_header_login.svg';
import SpLogoImg from 'ui/images/top_for_buyer/sp_many_logo_buyer.svg';
import { Only } from 'ui/components/elements/Only/Only';
import CloseIcon from 'ui/images/icons/close_icon.svg';

const Header = styled.header`
    width: 100%;
    background-color: var(--light-orange);
    font-weight: 700;
    transition:
        transform 0.3s ease,
        opacity 0.3s ease,
        background-color 0.3s;
    opacity: 1;

    ${mqUser('SP')} {
        background-color: ${({ isscrolled }) => (isscrolled ? 'rgba(239, 150, 41, 0.85)' : 'var(--light-orange)')};
        position: ${(props) => (props.isfixed ? 'fixed' : 'static')};
        top: 0;
        left: 0;
        z-index: 1000;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        &.hidden {
            transform: translateY(-100%);
            opacity: 0;
        }
    }
`;

const HeaderContent = styled.div`
    display: flex;
    align-items: center;
    width: 87.67441860465116%;
    padding: 25px 0 13px 0;
    margin: 0 auto 0 auto;

    ${mqMin('SP')} {
        align-items: center;
    }

    ${mqMin('NARROW')} {
        width: 92.01388888888889%;
    }
`;

const Title = styled.h1`
    width: 6rem;
    height: auto;
    font-size: 1rem;
    margin: 0 auto;

    img {
        width: 100%;
        cursor: pointer;
    }

    ${mqMin('SP')} {
        width: 10rem;
    }

    ${mqMin('NARROW')} {
        width: 152px;
        min-width: 152px;
        height: 83px;
        margin-bottom: auto;
    }
`;

const Nav = styled.nav`
    width: calc(100% - 98px);
    max-width: 340px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
    padding-bottom: 11px;

    ${mqMin('SP')} {
        max-width: initial;
    }

    ${mqMin('NARROW')} {
        width: fit-content;
    }
`;

const NavItem = styled.a`
    display: block;
    var(--font-large);
    text-align: center;
    cursor: pointer;
    padding: 6px 15px;
    font-weight: 700;
     white-space: nowrap;

    &:visited {
        color: var(--white);
    }

      &:hover {
        transform: scale(1.05);
        transition: transform 0.3s ease;
    }
`;

const LoginLink = styled(NavItem)`
    border: solid 1px var(--primary);
    border-radius: 7px;
    line-height: 1em;
    transition: all 0.3s;
    color: var(--primary);

    &:hover {
        color: var(--white);
        background-color: var(--primary);
    }
`;

const RegisterLink = styled(NavItem)`
    background-color: var(--orange);
    border: solid 1px #fff;
    border-radius: 7px;
    line-height: 1em;
    transition: all 0.3s;
    color: var(--white);
`;

const RegisterLinkForOther = styled(NavItem)`
    font-size: var(--font-default);
    margin-bottom: 18px;
    transition: all 0.3s;
    border: 1px solid #ffffff;
    box-shadow: 0px 4px 4px 0px #00000040;
    cursor: pointer;
    padding: 10px 15px;
    font-weight: 700;
    width: fit-content;
    border-radius: 7px;
    color: var(--white);

    ${mqMin('SP')} {
        margin: auto 0;
    }

    &:hover {
        color: var(--light-orange);
        background-color: var(--white);
        transform: scale(1.05);
        transition: transform 0.3s ease;
    }
`;

const Spacer = styled.div`
    display: none;
    ${mqUser('SP')} {
        display: block;
        height: 121px;
        background-color: var(--light-orange);
    }
`;

const CenterNav = styled.div`
    display: flex;
    justify-content: end;
    gap: 30px;
    color: var(--white);
    font-weight: 700;
    font-size: var(--font-large);
    width: 100%;
    white-space: nowrap;
    margin: 18px 40px auto auto;

    span {
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
        &:hover {
            transform: scale(1.05);
            transition: transform 0.3s ease;
        }
    }
`;

const ForBuyer = styled.div`
    display: flex;
    border-radius: 8px;
    background-color: var(--white);
    color: var(--dark-blue);
    padding: 12px 16px;
    align-items: center;
    width: fit-content;
    gap: 14px;

    span {
        font-size: 11px;
        white-space: nowrap;
        cursor: pointer;
    }
`;

const LinkContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const BuyerLoginButton = styled.div`
    img {
        width: 4.8rem;
        height: auto;
        cursor: pointer;

        ${mqMin('SP')} {
            width: 8rem;
        }
    }
`;

const HamburgerButton = styled.button`
    background: none;
    border: none;
    padding: 0 16px 0 0;
    display: ${(props) => (props.menuOpen ? 'none' : 'flex')};
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 2.7rem;
    cursor: pointer;
    z-index: 1201;

    span {
        display: block;
        width: 2.7rem;
        height: 4px;
        margin: 8px 0;
        background: #fff;
        border-radius: 2px;
        transition: 0.3s;
    }

    ${mqMin('SP')} {
        width: 5rem;

        span {
            width: 5rem;
        }
    }
`;

// スライドインメニュー
const MobileMenuDrawer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1200;
    display: flex;
    pointer-events: none;

    .drawer-content {
        width: 100vw;
        background: #fbf1e5;
        height: 100vh;
        overflow-y: auto;
        transform: translateX(-100%);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        pointer-events: auto;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    &.open .drawer-content {
        transform: translateX(0);
    }
    &.open {
        pointer-events: auto;
    }
`;

const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 4.3rem;
    height: 4.3rem;
    cursor: pointer;
    z-index: 1300;
    background-color: var(--white);
    border-radius: 0 0 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        width: 2rem;
        height: auto;
    }

    ${mqMin('SP')} {
        width: 6rem;
        height: 6rem;
        img {
            width: 3rem;
        }
    }
`;

const SpBlueLogo = styled.div`
    width: 6rem;
    height: auto;
    margin: 1rem auto;
    img {
        width: 100%;
    }

    ${mqMin('SP')} {
        width: 10rem;
    }
`;

const MenuContainer = styled.div`
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin: 2rem auto;

    ${mqMin('SP')} {
        width: 40rem;
    }
`;

const ForAgent = styled.div`
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem auto 3rem auto;

    ${mqMin('SP')} {
        width: 40rem;
    }
`;

const MenuItemForAgent = styled.div`
    width: 100%;
    background-color: var(--white);
    border-radius: 8px;
    border: 1px solid var(--dark-blue);
    padding: 1rem;
    color: var(--dark-blue);
    font-weight: 700;
    cursor: pointer;
    font-size: 1rem;

    ${mqMin('SP')} {
        padding: 1.5rem;
        font-size: 1.4rem;
    }
`;

const MenuItem = styled.div`
    width: 100%;
    background-color: var(--white);
    border-radius: 8px;
    padding: 1rem;
    color: var(--dark-blue);
    font-weight: 700;
    cursor: pointer;
    font-size: 1rem;

    ${mqMin('SP')} {
        padding: 1.5rem;
        font-size: 1.4rem;
    }
`;

const BuyerButtonContainer = styled.div`
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    background-color: var(--white);
    border-radius: 8px;
    padding: 1.6rem;
    color: var(--dark-blue);
    font-weight: 700;
    font-size: 1rem;
    margin: 0 auto;
    text-align: center;

    ${mqMin('SP')} {
        width: 40rem;
        font-size: 1.4rem;
    }
`;

const LoginButton = styled.button`
    background-color: var(--white);
    border: 1px solid var(--primary);
    border-radius: 8px;
    color: var(--primary);
    height: 3rem;
    font-weight: 700;
    cursor: pointer;
    font-size: 1rem;
    width: 17rem;
    margin: 1.2rem auto 0 auto;

    ${mqMin('SP')} {
        font-size: 1.4rem;
    }
`;

const SignupButton = styled.button`
    background-color: var(--orange);
    border: 1px solid var(--orange);
    border-radius: 8px;
    color: var(--white);
    height: 3rem;
    font-weight: 700;
    cursor: pointer;
    font-size: 1rem;
    width: 17rem;
    margin: 0 auto;

    ${mqMin('SP')} {
        font-size: 1.4rem;
    }
`;

const SpFooter = styled.div`
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--dark-blue);
    color: var(--white);
    gap: 1rem;
    font-size: 0.9rem;
    padding: 2rem 0.8rem;
    bottom: 0;
    position: relative;
    margin-top: auto;

    ${mqMin('SP')} {
        font-size: 1.2rem;
    }
`;

const SpMenuHeader = styled.div`
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fbf1e5;
    z-index: 10;
    flex-shrink: 0;
`;

const OtherLinkContainer = styled.div`
    display: flex;
    gap: 0.6rem;
    justify-content: center;
    align-items: center;
`;

export const TopHeaderForBuyer = () => {
    const navigate = useNavigate();
    const [isFixed, setIsFixed] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setIsFixed(scrollY > 0);
            setIsScrolled(scrollY > 0);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const goToBuyerRegister = () => {
        navigate('/buyer/send-registration-mail/');
        setMenuOpen(false);
    };
    const goToBuyerLogin = () => {
        navigate('/buyer/login/');
        setMenuOpen(false);
    };
    const goToAgentTop = () => {
        navigate('/agent/');
        setMenuOpen(false);
    };
    const goToCompanyTop = () => {
        navigate('/');
    };
    const goToBuyerTop = () => {
        navigate('/buyer/');
    };
    const scrollToAboutMany = () => {
        navigate('/buyer/#about-many');
        setMenuOpen(false);
    };
    const scrollToAboutService = () => {
        navigate('/buyer/#about-service');
        setMenuOpen(false);
    };
    const goToContact = () => {
        window.open('/contact/', '_blank');
        setMenuOpen(false);
    };
    const scrollToNews = () => {
        navigate('/buyer/#news');
        setMenuOpen(false);
    };
    const goToQA = () => {
        navigate('/buyer/#qa');
        setMenuOpen(false);
    };
    const goToTerms = () => {
        window.open('/terms/', '_blank');
        setMenuOpen(false);
    };
    const goToPrivacyPolicy = () => {
        window.open('/privacy/', '_blank');
        setMenuOpen(false);
    };
    const goToCompanyProfile = () => {
        window.open('/company_profile/', '_blank');
        setMenuOpen(false);
    };
    return (
        <>
            <Header className="kv-section" isfixed={isFixed} isscrolled={isScrolled}>
                <Only pc>
                    <HeaderContent>
                        <Title onClick={goToBuyerTop}>
                            <img src={LogoImg} alt="MAny" />
                        </Title>
                        <CenterNav>
                            <span onClick={scrollToAboutMany}>MAnyとは</span>
                            <span onClick={scrollToNews}>最新のお知らせ</span>
                            <span onClick={scrollToAboutService}>サービスの流れ</span>
                            <span onClick={goToContact}>お問い合わせ</span>
                        </CenterNav>
                        <Nav>
                            <ForBuyer>
                                <span>買い手企業の方</span>
                                <LinkContainer>
                                    <LoginLink onClick={goToBuyerLogin}>ログイン</LoginLink>
                                    <RegisterLink onClick={goToBuyerRegister}>新規登録</RegisterLink>
                                </LinkContainer>
                            </ForBuyer>
                            <OtherLinkContainer>
                                <RegisterLinkForOther onClick={goToCompanyTop}>
                                    売り手企業の方はこちら
                                </RegisterLinkForOther>
                                <RegisterLinkForOther onClick={goToAgentTop}>
                                    M&A専門家の方はこちら
                                </RegisterLinkForOther>
                            </OtherLinkContainer>
                        </Nav>
                    </HeaderContent>
                </Only>
                <Only sp>
                    <HeaderContent>
                        <HamburgerButton
                            menuOpen={menuOpen}
                            onClick={() => setMenuOpen(true)}
                            aria-label="メニューを開く"
                        >
                            <span />
                            <span />
                        </HamburgerButton>
                        <Title onClick={goToBuyerTop}>
                            <img src={LogoImg} alt="MAny" />
                        </Title>
                        <BuyerLoginButton onClick={goToBuyerLogin}>
                            <img src={BuyerLoginImg} alt="買い手企業ログイン" />
                        </BuyerLoginButton>
                    </HeaderContent>
                </Only>
            </Header>
            {/* スライドインメニュー */}
            <MobileMenuDrawer className={menuOpen ? 'open' : ''}>
                <div className="drawer-content">
                    <SpMenuHeader>
                        <SpBlueLogo>
                            <img src={SpLogoImg} alt="MAny" onClick={goToBuyerTop} />
                        </SpBlueLogo>
                        <CloseButton onClick={() => setMenuOpen(false)}>
                            <img src={CloseIcon} alt="メニューを閉じる" />
                        </CloseButton>
                    </SpMenuHeader>
                    <MenuContainer>
                        <MenuItem onClick={scrollToAboutMany}>MAnyとは</MenuItem>
                        <MenuItem onClick={scrollToNews}>最新のお知らせ</MenuItem>
                        <MenuItem onClick={scrollToAboutService}>サービスの流れ</MenuItem>
                        <MenuItem onClick={goToQA}>よくある質問</MenuItem>
                        <MenuItem onClick={goToContact}>お問い合わせ</MenuItem>
                    </MenuContainer>
                    <BuyerButtonContainer>
                        買い手企業の方
                        <LoginButton onClick={goToBuyerLogin}>ログイン</LoginButton>
                        <SignupButton onClick={goToBuyerRegister}>新規登録</SignupButton>
                    </BuyerButtonContainer>
                    <ForAgent>
                        <MenuItemForAgent onClick={goToCompanyTop}>売り手企業の方はこちら</MenuItemForAgent>
                        <MenuItemForAgent onClick={goToAgentTop}>M&A専門家の方はこちら</MenuItemForAgent>
                    </ForAgent>
                    <SpFooter>
                        <span onClick={goToTerms}>利用規約</span>
                        <span onClick={goToPrivacyPolicy}>プライバシーポリシー</span>
                        <span onClick={goToCompanyProfile}>運営会社</span>
                    </SpFooter>
                </div>
            </MobileMenuDrawer>
            {isFixed && (
                <Only sp>
                    <Spacer className="sp-only" style={{ height: '121px' }} />
                </Only>
            )}
        </>
    );
};
